var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardDropdownArrow = function SvgNewcsDashboardDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5.997
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M5 5.997a.7.7 0 0 1-.505-.22L.21 1.277a.776.776 0 0 1 0-1.061.69.69 0 0 1 1.011 0l3.78 3.967L8.781.216a.69.69 0 0 1 1.011 0 .776.776 0 0 1 0 1.061l-4.285 4.5a.7.7 0 0 1-.507.22",
    opacity: 0.8
  })));
};
export default SvgNewcsDashboardDropdownArrow;